import { createGlobalStyle } from 'styled-components';

// TODO: Delete this component after Poppins font is released into global styles.
const GlobalStyles = createGlobalStyle`
/* devanagari */
@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrJJbecmNE.woff2) format('woff2');
  unicode-range: U+0900-097F, U+1CD0-1CF6, U+1CF8-1CF9, U+200C-200D, U+20A8, U+20B9, U+25CC, U+A830-A839, U+A8E0-A8FB;
}
/* latin-ext */
@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrJJnecmNE.woff2) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrJJfecg.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* devanagari */
@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6Z11lFc-K.woff2) format('woff2');
  unicode-range: U+0900-097F, U+1CD0-1CF6, U+1CF8-1CF9, U+200C-200D, U+20A8, U+20B9, U+25CC, U+A830-A839, U+A8E0-A8FB;
}
/* latin-ext */
@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6Z1JlFc-K.woff2) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6Z1xlFQ.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

.font-poppins {
  font-family: 'Poppins', sans-serif !important;
  -moz-font-feature-settings: "ss02" !important;
  -webkit-font-feature-settings: "ss02" !important;
  font-feature-settings: "ss02" !important;
}

.bg-evelate-dark-00dp {
  background-color: #050823;
}

.bg-evelate-dark-03dp {
  background-color: #21243F;
}

.bg-evelate-dark-04dp {
  background-color: #292C47;
}


.bg-gray-neutral-light-200 {
  background-color: #F7F8FA;
}

.bg-primary-light-100 {
  background-color: #F5F0FF;
}

.hover-bg-primary-light-100:hover {
  background-color: #F5F0FF;
}

.bg-primary-dark-100 {
  background-color: #EEE6FE;
}

.bg-neutral-dark-700 {
  background-color: #33344F;
}
.bg-neutral-dark-600 {
  background-color: #70738E;
}

.hover-bg-neutral-dark-600:hover{
  background-color: #70738E;
}

.text-neutral-dark-800 {
  color: #050823 !important
}

input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active{
    -webkit-box-shadow: 0 0 0 1000px #21243F inset !important;
    box-shadow: 0 0 0 1000px #21243F inset !important;
    border-radius: 10px;
    border-color: #21243F;
}

html {
      height: 100%;
  }
  body {
    width: 100%;
    height: 100%;
    margin: 0;
    background-color: #050823;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
  }

`;

export default GlobalStyles;
